<template>
  <div class="collapsible">
    <!-- Header -->
    <div class="header" @click="open = !open">
      <span>{{ title }}</span>

      <!-- Icon -->
      <span class="icon">
        {{ open ? "▼" : "▶" }}
      </span>
    </div>

    <!-- Content -->
    <div v-if="open" class="content">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "Section Title"
  }
});

const open = ref(false); // collapsed by default
</script>

<style scoped>
.collapsible {
  border: 1px solid #ddd;
  border-radius: 6px;

  overflow: hidden;
  background: white;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  font-weight: bold;
  cursor: pointer;
  background: #f7f7f7;
  user-select: none;
}

.content {
  padding: 12px;
  animation: fadeIn 0.25s ease;
}

.icon {
  font-size: 14px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
</style>
